import * as actions from "./actions";
import * as chartHeaderActions from "../chart-header/actions";
import webStorageManager from "../../../services/managers/web-storage";
import pagePreloaderManager from "../../../services/managers/page-preloader";
import { STORAGE_KEY_WHITEBOARD_DATA } from "../../../services/managers/constants";

export const onSelectedGranularityChange = (payload) => (dispatch, getState) => {
  if (
    getState().analytics.chartWhiteboards[payload.whiteboardIndex].chartDrawings.length &&
    !getState().analytics.chartWhiteboards[payload.whiteboardIndex].isObsolete
  ) {
    // Dispatch 'ON_VIEW_CHART_CLICK' to redraw Chart with locally available data
    pagePreloaderManager.showChartLoader(payload.whiteboardIndex, "Redrawing chart");
    dispatch(
      (() => ({
        type: chartHeaderActions.ON_VIEW_CHART_CLICK,
        payload: {
          ...payload,
          response: webStorageManager.get(STORAGE_KEY_WHITEBOARD_DATA + payload.whiteboardIndex),
          shouldChartBeRedrawnWithLocallyAvailableDataOnGranularityChange: true
        }
      }))()
    );
  } else {
    // Dispatch 'ON_SELECTED_GRANULARITY_CHANGE' without redrawing Chart
    dispatch((() => ({ type: actions.ON_SELECTED_GRANULARITY_CHANGE, payload: { ...payload } }))());
  }
};



// WEBPACK FOOTER //
// ./src/store/analytics/chart-granularity/action-creators.js